import React, { useState, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { useForm, Controller } from 'react-hook-form';
import {Stack, Button, CircularProgress,Backdrop,Box,MenuItem,Link, FormControlLabel,Dialog, DialogActions,DialogContent,DialogContentText,DialogTitle, TextField, FormHelperText, Checkbox, Typography } from '@mui/material';

import axios from 'axios';


function Entry(){

    const serverUrl=`https://script.google.com/macros/s/AKfycbzBH-da3Cnx7crb617qZbw0elUzMLgn53vOkTiY2nNgTzZOBsiNvedbWYll55dS2VGizg/exec`
    const VALIDATION_REQUIRED="入力が必須の項目です"
    
    const {
        control,
        handleSubmit,
        resetField,
    } = useForm();

   
    
    // クエリストリングより、アンケートのリクエストIDを取得
    const [searchParams] = useSearchParams();
    const partnerId = searchParams.get("p");
    const salesId = searchParams.get("e");
    const campaignId = searchParams.get("ca");
    const [serviceInfo,setServiceInfo] = useState(null)

    const [stepNo,setStepNo] = useState(1);
    const [issueId,setIssueId]=useState("");
    
    const [isProcessing,setIsProcessing] = useState(false);
    const [dialogInfo,setDialogInfo]=useState(null);
    
    const [meetingList, setMeetingList]=useState([]);
    const [reserveInfo, setReserveInfo]=useState({});

    const [headerImageFileNo,setHeaderImageFileNo]=useState("001")

    const [filters,setFilters]=useState([
        // {label:"厚労省管轄の助成金について知りたい（経産省管轄の補助金ではない）",value:false},
        {label:"雇用保険に加入している社員が１名以上在籍している",value:false},
        {label:"社労士関連、助成金や労務コンサルティング会社ではない",value:false},
        {label:"社会保険料や残業代等の適切な支払い等、法令遵守できる",value:false},
        {label:"性風俗関連業、接待を伴う飲食業、これらの営業の一部を受託する事業ではない",value:false},
        {label:"暴力団との関わりは一切ない",value:false},
    ])

    const industryItems = ["情報通信業（IT）","サービス業","理美容業","小売業","飲食業","建設業","製造業","教育・学習支援業","卸売業","医療業","介護業","不動産業","運輸業","宿泊業","保育業","娯楽業","金融・保険業","農業・林業・漁業","その他"]
    const prefectureItems = ["北海道","青森県","岩手県","宮城県","秋田県","山形県","福島県","茨城県","栃木県","群馬県","埼玉県","千葉県","東京都","神奈川県","新潟県","富山県","石川県","福井県","山梨県","長野県","岐阜県","静岡県","愛知県","三重県","滋賀県","京都府","大阪府","兵庫県","奈良県","和歌山県","鳥取県","島根県","岡山県","広島県","山口県","徳島県","香川県","愛媛県","高知県","福岡県","佐賀県","長崎県","熊本県","大分県","宮崎県","鹿児島県","沖縄県"]

    const [confirmLinks,setConfirmLinks]=useState([])


    
    const showInfoMessage = (message)=>{
        setDialogInfo({
            title:"Infomation",
            message:message
        })
    }

    const showErrorMessage = (message)=>{
        setDialogInfo({
            title:"Error",
            message:message
        })
    }

    const goNextStep=()=>{
        setStepNo(stepNo+1)
    }

    const goPrevStep=()=>{
        setStepNo(stepNo-1)
    }

    useEffect(()=>{
        setIsProcessing(true);

        // 日税＋専用キャンペーンコードの場合は、ヘッダー画像の差し替え
        if(partnerId === "f825e25ad86c4e45a030371188c4e7de" && campaignId === "b00016c202310002"){
            setHeaderImageFileNo("002");
        }
        
        if(partnerId === null){
            setIsProcessing(false)
            showErrorMessage("URLを確認してください。")
            return;
        }

        (async ()=>{
            try{

                const response = await axios.post(serverUrl,JSON.stringify({
                    p:partnerId,
                    e:salesId,
                    ca:campaignId,
                    rm:"dc8eaffa6c83495bbcccd2e6ea66e3c8"
                }));
                        
                if(response.status !== 200){
                    throw new Error(`request error\n${response.status} ${response.statusText}`);
                }

                const {status, data, message} = response.data;
                switch(status){
                    case "OK":
                        // console.log(data);
                        setServiceInfo(data.serviceInfo);
                        setConfirmLinks(data.confirmLinks);
                        setStepNo(data.startStepNo);
                        
                        break;
                
                    case "ERROR":
                        throw new Error(message);

                    default:
                        throw new Error("Out of range");
                }
            }
            catch(ex){
                showErrorMessage(ex.message)
            }
            finally{
                setIsProcessing(false);
                
            }
        })()
    },[])

    

    const onsubmit_issue = async(formData)=>{     

        try{
            setIsProcessing(true)
            formData.rm = "60dee68240fc4a0eba53c114ee677e65";
            
            const response = await axios.post(serverUrl,JSON.stringify(formData));
            
            if(response.status !== 200){
                throw new Error(`request error\n${response.status} ${response.statusText}`);
            }

            const {status, data, message} = response.data;

            if(status !== "OK"){
                throw new Error(message);
            }
            
            
            setIssueId(data.issueId)
            goNextStep();
            
        }
        catch(ex){
            showErrorMessage(ex.message)
        }
        finally{
            setIsProcessing(false)
        }
    }

    const onsubmit_verify = async(formData)=>{
        
        try{
            setIsProcessing(true)

            formData.rm = "2ee4913f81c949f8a0a119e6a8c7ba10";
            formData.issueId = issueId;
            formData.e = salesId;
            formData.p = partnerId
            
            const response = await axios.post(serverUrl,JSON.stringify(formData));
            
            if(response.status !== 200){
                throw new Error(`request error\n${response.status} ${response.statusText}`);
            }

            const {status, data, message} = response.data;

            switch(status){
                case "OK":

                    switch(data.verifyResult){
                        case "SUCCESS":

                            setMeetingList(data.availableDateList)

                            goNextStep();
                            
                            if(data.trainingInfo !== void 0){

                                
                            }
                            break;

                        case "BADREQUEST":
                            resetField("verifyCode")
                            goPrevStep();
                            showInfoMessage("「確認コード」を再発行のうえ、再度ご確認お願いいたします。")
                            break;

                        default:
                            resetField("verifyCode")
                            break;
                    }

                    break;

                default:
                    throw new Error(message);
            }
        }
        catch(ex){
            showErrorMessage(ex.message)
        }
        finally{
            setIsProcessing(false)
        }
    }

    const onSubmit = async(formData)=>{

        try{
            setIsProcessing(true)
            
            formData.rm="1cf86093c7af45f7be9c6993ab024ddd"
            formData.issueId = issueId;
            formData.p = partnerId
            formData.c = campaignId
            
            formData.meetingInfo=meetingList.find(item=>item.eId === formData.meetingId);

            // console.log(formData)
            
            const response = await axios.post(serverUrl,JSON.stringify(formData));
            
            if(response.status !== 200){
                throw new Error(`request error\n${response.status} ${response.statusText}`);
            }

            const {status, data, message} = response.data;

            switch(status){
                case "OK":
                    setReserveInfo(data.reserveInfo)
                    goNextStep();
                    break;

                case "RETRY":
                    resetField("meetingId")
                    setMeetingList(data.availableDateList)
                    showInfoMessage(message)
                    break;

                default:
                    throw new Error(message);
            }

        }
        catch(ex){
            showErrorMessage(ex.message)
        }
        finally{
            setIsProcessing(false)
        } 
    }

    
    
    return(
        
        <Box className='App-Container'>
            <Box maxWidth="800px" m="0 auto" pb={12}>

                <Box component="img" alt="header" src={`${process.env.PUBLIC_URL}/static/media/entry_header_${headerImageFileNo}.png`} sx={{verticalAlign:"middle"}}></Box>
                
                {serviceInfo!=null &&
                <>
                    
                    <Box textAlign="center" fontWeight="bold" fontSize={{xs:"1.2rem",md:"1.5rem"}} pt={{xs:2,md:3}} pb={{xs:2,md:3}} bgcolor="#C8E4FF">{serviceInfo?.serviceName}</Box>
                    
                   
                    {stepNo===1 &&
                    <>
                        <Box color="#454545" bgcolor="#C8E4FF" pl={{xs:2,md:4}}  pr={{xs:2,md:4}} pb={{xs:8,md:12}}>
                            <Box>約60種ある全助成金の中から今すぐ活用できる助成金を、個別ヒアリングの上その場で解説します。</Box>
                            <Box mt={2}>年間3,000社にコンサルしている「助成金の専門家」だからできる、新しい助成金診断！</Box>
                            {serviceInfo.partnerId === "5b8e3e831aee453ba9c21975fa6ef45d" &&
                                <Box mt={2}>予約完了後にChatworkのグループチャットに参加でき、チャットでも簡単に問い合わせができます。</Box>
                            }
                            <Box mt={2}>助成金申請に必要な下記の項目すべてに同意のうえ、個別オンライン面談のご予約にお進みください。</Box>
                        </Box>

                        <Box bgcolor="#E8E8E8" p={{xs:2,md:4}}>
                            <Stack mt={{xs:-8,md:-13}} p={{xs:2,md:4}} borderRadius={1} bgcolor="white">

                                <Box textAlign="center">
                                    <Box component="span" pl={2} pr={2} color="#FF2A52" borderBottom="1px solid #FF2A52">下記のチェック項目をご確認ください</Box>
                                </Box>

                                {filters.map((item,index) => 
                                <FormControlLabel
                                        key={"check"+index}
                                        control={<Checkbox autoFocus={index===0}/>}
                                        label={item.label}
                                        sx={{mt:"2rem"}}
                                        onChange={(e)=>{
                                            filters[index].value = !filters[index].value 
                                            setFilters([...filters]);
                                        }}
                                    /> 
                                )}
                            </Stack>
                            <Box mt={1}>※１項目でも当てはまらない場合は面談ができません。</Box>
                        </Box>
                        

                        <Stack direction={'row'} spacing={2} justifyContent={"center"} alignItems={"center"} mt={{xs:2,md:3}}>
                            <Button type="button" variant="contained" size="large" sx={{minWidth:"150px",borderRadius:"100px"}} disabled={!filters.every(item=>item.value===true)} onClick={()=>{
                                goNextStep();
                            }}>次　へ</Button>
                        </Stack>
                    </>
                    }

                    {stepNo===2 &&
                        <Box component="form" onSubmit={handleSubmit(onsubmit_issue)}>
                            <Box bgcolor="#E8E8E8" p={{xs:2,md:4}}>
                                <Box p={{xs:2,md:4}} borderRadius={1} bgcolor="white">
                                    <Box component="fieldset" disabled={isProcessing}>
                                        <div>メールアドレスをご指定いただき［送信する］ボタンを押してください。</div>
                                        <FormHelperText>※指定のメールアドレスに「確認コード」が送信されます。</FormHelperText>
                                        
                                        
                                            {/* <fieldset disabled={isProcessing}> */}
                                                <Controller
                                                    name="email"
                                                    control={control}
                                                    defaultValue=""
                                                    rules={{
                                                        required: {value: true, message: VALIDATION_REQUIRED},
                                                        pattern:{value:/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,message:'xxx@xxx.xx形式で入力してください'},
                                                    }}
                                                    render={({field,fieldState})=>
                                                        <TextField 
                                                            {...field}
                                                            // required
                                                            autoFocus
                                                            variant="outlined"
                                                            label="メールアドレス"
                                                            margin="normal"
                                                            fullWidth
                                                            error={!!fieldState.error?.message}
                                                            helperText={fieldState.error?.message}
                                                            />
                                                    }
                                                />
                                            {/* </fieldset> */}
                                    </Box>
                                </Box>
                            </Box>             
                            <Stack direction={'row'} spacing={2} justifyContent={"center"} alignItems={"center"} mt={{xs:2,md:3}}>
                                <Button type="submit" variant="contained" size="large" sx={{minWidth:"150px",borderRadius:"100px"}} disabled={isProcessing}>送信する</Button>
                            </Stack>   
                        </Box>
                    }

                    {stepNo===3 &&
                        <Box component="form" onSubmit={handleSubmit(onsubmit_verify)}>
                            <Box bgcolor="#E8E8E8" p={{xs:2,md:4}}>
                                <Box p={{xs:2,md:4}} borderRadius={1} bgcolor="white">
                                    <Box component="fieldset" disabled={isProcessing}>
                                        <div>受信メールをご確認いただき、メール本文の確認コード（数字6桁）をご入力のうえ［送信する］ボタンを押してください。</div>
                                        <FormHelperText>※確認コードが届かない場合は［戻る］ボタンを押し、確認コードの送信を再度お試しください。</FormHelperText>
                                    
                                        {/* <fieldset disabled={isProcessing}> */}

                                            <Controller
                                                name="email"
                                                control={control}
                                                defaultValue=""
                                                render={({field,fieldState})=>
                                                    
                                                    <TextField 
                                                        {...field}
                                                        disabled
                                                        sx={{background:"#f0f0f0"}}
                                                        label="メールアドレス"
                                                        margin="normal"
                                                        fullWidth
                                                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} 
                                                        error={!!fieldState.error?.message}
                                                        helperText={fieldState.error?.message}
                                                        />
                                                    
                                                }
                                            />

                                            <Controller
                                                name="verifyCode"
                                                control={control}
                                                defaultValue=""
                                                rules={{
                                                    required: {value: true, message: '半角数字6桁を入力してください'},
                                                    pattern:{value:/^[0-9]{6}$/,message:'半角数字6桁を入力してください'},
                                                }}
                                                render={({field,fieldState})=>
                                                    
                                                    <TextField 
                                                        {...field}
                                                        autoFocus
                                                        variant="outlined"
                                                        label="確認コード"
                                                        margin="normal"
                                                        fullWidth
                                                        error={!!fieldState.error?.message}
                                                        helperText={fieldState.error?.message}
                                                        />
                                                    
                                                }
                                            />
                                        {/* </fieldset> */}

                                    </Box>
                                </Box>
                            </Box>
                            <Stack direction={'row'} spacing={2} justifyContent={"center"} alignItems={"center"} mt={{xs:2,md:3}}>
                                <Button type="button" variant="outlined" size="large" sx={{minWidth:"80px",borderRadius:"100px"}} disabled={isProcessing} onClick={()=>{setStepNo(stepNo-1)}} tabIndex={-1}>戻る</Button>
                                <Button type="submit" variant="contained" sx={{minWidth:"150px",borderRadius:"100px"}} disabled={isProcessing}>送信する</Button>
                            </Stack>
                        </Box>
                    }

                    {stepNo===4 &&
                        <Box component="form" onSubmit={handleSubmit(onSubmit)}>

                            <Box component="fieldset" disabled={isProcessing} bgcolor="#E8E8E8" p={{xs:2,md:4}}>
                                <Box p={{xs:2,md:4}} borderRadius={1} bgcolor="white">
                                    <div>貴社の会社情報をご入力ください。</div>
                                    <Controller
                                        name="accountName"
                                        control={control}
                                        defaultValue={""}
                                        rules={{
                                            required: {value: true, message: VALIDATION_REQUIRED},
                                            maxLength:{value:60,message:"60文字以内で入力してください"},
                                        }}
                                        render={({field,fieldState})=>
                                            
                                            <TextField 
                                                {...field}
                                                autoFocus
                                                variant="outlined"
                                                label="会社名"
                                                margin="normal"
                                                fullWidth
                                                error={!!fieldState.error?.message}
                                                helperText={fieldState.error?.message}
                                                />
                                                
                                        }
                                    />

                                    <Controller
                                        name="customerName"
                                        control={control}
                                        defaultValue={""}
                                        rules={{
                                            required: {value: true, message: VALIDATION_REQUIRED},
                                            maxLength:{value:60,message:"60文字以内で入力してください"},
                                        }}
                                        render={({field,fieldState})=>
                                        
                                            <TextField 
                                                {...field}
                                                variant="outlined"
                                                label="担当者名"
                                                margin="normal"
                                                fullWidth
                                                error={!!fieldState.error?.message}
                                                helperText={fieldState.error?.message}
                                                />
                                                
                                        }
                                    />

                                    <Controller
                                        name="industry"
                                        control={control}
                                        defaultValue={""}
                                        rules={{
                                            required: {value: true, message: VALIDATION_REQUIRED}
                                        }}
                                        render={({field,fieldState})=>
                                                
                                            <TextField 
                                                {...field}
                                                select
                                                variant="outlined"
                                                label="業種"
                                                margin="normal"
                                                fullWidth
                                                error={!!fieldState.error?.message}
                                                helperText={fieldState.error?.message}
                                                >
                                                    {industryItems.map((item,index)=>{
                                                        return <MenuItem key={"item"+index} value={item}>{item}</MenuItem>
                                                    })}
                                            </TextField>   
                                        }
                                    />

                                    <Controller
                                        name="prefectures"
                                        control={control}
                                        defaultValue={""}
                                        rules={{
                                            required: {value: true, message: VALIDATION_REQUIRED}
                                        }}
                                        render={({field,fieldState})=>
                                                
                                            <TextField 
                                                {...field}
                                                select
                                                variant="outlined"
                                                label="会社所在地"
                                                margin="normal"
                                                fullWidth
                                                error={!!fieldState.error?.message}
                                                helperText={fieldState.error?.message}
                                                >
                                                    {prefectureItems.map((item,index)=>{
                                                        return <MenuItem key={"item"+index} value={item}>{item}</MenuItem>
                                                    })}
                                            </TextField>   
                                        }
                                    />

                                    <Controller
                                        name="phone"
                                        control={control}
                                        defaultValue=""
                                        rules={{
                                            required: {value: true, message: VALIDATION_REQUIRED},
                                            pattern:{value:/^0\d{1,4}[-]?\d{1,4}[-]?\d{4}$/,message:'半角数字で電話番号を入力してください'},
                                        }}
                                        render={({field,fieldState})=>
                                            
                                            <TextField 
                                                {...field}
                                                variant="outlined"
                                                label="日中繋がりやすい電話番号"
                                                margin="normal"
                                                fullWidth
                                                error={!!fieldState.error?.message}
                                                helperText={fieldState.error?.message}
                                                />
                                                
                                        }
                                    />

                                    <Controller
                                        name="dispatchBusiness"
                                        control={control}
                                        defaultValue={""}
                                        rules={{
                                            required: {value: true, message: VALIDATION_REQUIRED}
                                        }}
                                        render={({field,fieldState})=>
                                                
                                            <TextField 
                                                {...field}
                                                select
                                                variant="outlined"
                                                label="派遣業の許可"
                                                margin="normal"
                                                fullWidth
                                                error={!!fieldState.error?.message}
                                                helperText={fieldState.error?.message}
                                                >
                                                    <MenuItem key={"item0"} value="取得していない">取得していない</MenuItem>
                                                    <MenuItem key={"item1"} value="取得している">取得している</MenuItem>
                                                    <MenuItem key={"item2"} value="不明">不明</MenuItem>
                                            </TextField>   
                                        }
                                    />

                                </Box>

                                <Box p={{xs:2,md:4}} borderRadius={1} bgcolor="white" mt={{xs:2,md:3}}>
                                    <Typography>無料コンサルティングのお打ち合わせ日時を選択してください。</Typography>
                                    
                                    <Controller
                                        name="meetingId"
                                        control={control}
                                        defaultValue={""}
                                        rules={{
                                            required: {value: true, message: VALIDATION_REQUIRED}
                                        }}
                                        render={({field,fieldState})=>
                                                
                                            <TextField 
                                                {...field}
                                                select
                                                variant="outlined"
                                                label="打ち合わせ日時"
                                                margin="normal"
                                                fullWidth
                                                error={!!fieldState.error?.message}
                                                helperText={fieldState.error?.message}
                                                >
                                                    {meetingList.map((item)=>{
                                                        return <MenuItem key={item.eId} value={item.eId}>{item.label}</MenuItem>
                                                    })}
                                            </TextField>   
                                        }
                                    />

                                    <Box border="1px solid lightgray" borderRadius={1} bgcolor="#ffffdd" p={2}>
                                        <Typography >
                                        助成金制度は、会社全体の制度設計や会社経営に直結する内容となります。<br/>
                                        そのため、ご説明当日は<Typography component="span" color="red">「経営者様」</Typography>もしくは<Typography component="span" color="red">「人事労務ご担当者様」</Typography>のご参加をお願いしております。<br/>
                                        ※社外の方（顧問先など）はご遠慮いただいております。
                                        </Typography>
                                    </Box>
                                </Box>


                                <Stack p={{xs:2,md:4}} borderRadius={1} bgcolor="white" mt={{xs:2,md:3}} spacing={2}>
                                    {confirmLinks.map((item,index)=>{
                                        return (<Link key={"item"+index} href={item.link} target="_blank">{item.label}</Link>)
                                    })}
                                </Stack>
                            </Box>

                            <Stack direction={'column'} mt={{xs:2,md:3}} spacing={2} justifyContent={"center"} alignItems={"center"}>
                                <Button type="submit" variant="contained" size="large" sx={{minWidth:"150px",borderRadius:"100px",mt:2}} disabled={isProcessing}>上記に同意のうえ送信する</Button>
                            </Stack>
                        </Box>
                    }

                    {stepNo===5 &&
                        <Box bgcolor="#E8E8E8" p={{xs:2,md:4}}>
                            <Box p={{xs:2,md:4}} borderRadius={1} bgcolor="white">
                                「無料コンサルティング」にお申し込みいただき、誠にありがとうございます。<br/><br/>
                                ご予約内容は以下の通りとなります。
                                <Box border="1px solid lightgray" borderRadius={1} bgcolor="#ffffdd" p={2}>
                                    <Box>＜日時＞</Box>
                                    <Box>{reserveInfo?.label}</Box>
                                    <Box borderBottom="1px solid lightgray" mt={1} mb={1}></Box>
                                    <Box>＜お打ち合わせURL＞</Box>
                                    <Link href={reserveInfo.link} target="_blank">{reserveInfo.link}</Link>
                                    <FormHelperText>※Google Meetにて実施いたします</FormHelperText>
                                </Box>
                                <FormHelperText>※ご予約結果につきましては、メールアドレス宛てにも送信しております。</FormHelperText>
                                
                                <Box mt={2}>その他、ご不明点等ございましたら <Link  href="mailto:jsupport@triport.co.jp" target="_blank">jsupport@triport.co.jp</Link> までご連絡いただければと存じます。</Box>                    

                            </Box>
                        </Box>
                    }
                    
                </>
                }
                
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={isProcessing}>
                    <CircularProgress style={{width:"60px",height:"60px"}} />
                </Backdrop>
                
                <Dialog
                    fullWidth={true}
                    maxWidth={"md"}
                    open={dialogInfo != null}
                    onClose={() => { setDialogInfo(null); }}>
                    <DialogTitle>{dialogInfo?.title}</DialogTitle>
                    <DialogContent dividers sx={{overflowWrap:"break-word",whiteSpace:"pre-line"}}>
                        <DialogContentText>{dialogInfo?.message}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setDialogInfo(null); }} autoFocus>閉じる</Button>
                    </DialogActions>
                </Dialog>
               
            </Box>
            <Box sx={{position:"fixed",bottom:"0",left:"0",right:"0",background:"#E8E8E8",color:"#3F3F3F", padding:"5px 0", textAlign: "center"}}>2024 TRIPORT</Box>
        </Box>
    )
}

export default Entry;